import API from 'utils/api';
import Logger from 'utils/logger';

type RefreshListener = () => void;

let inFlight: Promise<void> | null = null;
let onRefreshed: RefreshListener | undefined;

export function setSessionRefreshedListener(listener: RefreshListener | undefined): void {
  onRefreshed = listener;
}

export function refreshSession(): Promise<void> {
  if (!inFlight) {
    inFlight = API.common
      .refreshSession()()
      .then(() => {
        try {
          onRefreshed?.();
        } catch (e) {
          Logger.error('Session refreshed listener failed', e);
        }
      })
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
}
